<template lang="pug">
  div
    div(style="display: flex;")
      overview(style="padding: 20px; flex: 1;")
    div(style="display: flex;")
      unresolved-breakdown(style="padding: 20px; flex: 1;")
      div(style="border-right: 1px solid grey; margin: 20px 30px;")
      resolved-breakdown(style="padding: 20px; flex: 1;")
    div
      custom-map
</template>

<script>
import CustomMap from "./Dashboard/Map.vue";
import Overview from "./Dashboard/Overview.vue";
import ResolvedBreakdown from "./Dashboard/ResolvedBreakdown.vue";
import UnresolvedBreakdown from "./Dashboard/UnresolvedBreakdown.vue";

export default {
  name: "dashboard",
  components: {
    CustomMap,
    Overview,
    ResolvedBreakdown,
    UnresolvedBreakdown
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue